exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lZG6pxSu4DLoUV1sb2knA{max-width:600px!important}._3MRSs8nJUC0n_yOgGwEDt1{font-size:17px;font-weight:300}html[dir] ._3MRSs8nJUC0n_yOgGwEDt1{margin-top:10px;margin-bottom:10px}.RGxGLJygV1PAzAsZgF05i{width:400px}._1JMQ8JLV32P_6eNhVffXv1{display:inline-block}", ""]);

// exports
exports.locals = {
	"dialog": "lZG6pxSu4DLoUV1sb2knA",
	"title": "_3MRSs8nJUC0n_yOgGwEDt1",
	"textbox": "RGxGLJygV1PAzAsZgF05i",
	"spinner": "_1JMQ8JLV32P_6eNhVffXv1"
};